import { classNames } from 'primereact/utils';
import { Link, useNavigate } from 'react-router-dom';
import AppBreadcrumb from './AppBreadcrumb';
import AppMenu from './AppMenu';

const AppTopbar = (props) => {
  const navigate = useNavigate();
  const notificationsItemClassName = classNames('notifications-item', { 'active-menuitem': props.topbarNotificationMenuActive });
  const profileItemClassName = classNames('profile-item', { 'active-menuitem fadeInDown': props.topbarUserMenuActive });

  const logout = () => {
    sessionStorage.clear();
    navigate('/');
  }

  return (
    <div className="layout-topbar">
      <div className="topbar-left">
        <button type="button" className="menu-button p-link" onClick={props.onMenuButtonClick}>

          <i className="pi pi-chevron-left"></i>
        </button>

        <Link to="/">
          <img id="logo-horizontal" className="horizontal-logo" src="/img/logo.svg" alt="diamond-layout" />
        </Link>

        <span className="topbar-separator"></span>

        <div className="layout-breadcrumb viewname" style={{ textTransform: 'uppercase' }}>
          <AppBreadcrumb meta={props.meta} />
        </div>

        <img id="logo-mobile" className="mobile-logo" src="img/logo_m.svg" alt="diamond-layout" />

      </div>

      <AppMenu
        model={props.menu}
        menuMode={props.menuMode}
        active={props.menuActive}
        mobileMenuActive={props.staticMenuMobileActive}
        onMenuClick={props.onMenuClick}
        onMenuitemClick={props.onMenuitemClick}
        onRootMenuitemClick={props.onRootMenuitemClick}
      ></AppMenu>

      <div className="layout-mask modal-in"></div>

      <div className="topbar-right">
        <ul className="topbar-menu">
          <li className={notificationsItemClassName}>

          </li>
          <li className={profileItemClassName}>
            <button type="button" className="p-link" onClick={props.onTopbarUserMenu}>
              <img src="/img/user-icon.png" alt="diamond-layout" className="profile-image" />
              <span className="profile-name">{JSON.parse(sessionStorage.getItem('auth') + "")?.name}</span>
            </button>
            <ul className="profile-menu fade-in-up">
              <li>
                <button type="button" className="p-link" onClick={() => { navigate('/profile') }}>
                  <i className="pi pi-user"></i>
                  <span>Profile</span>
                </button>
              </li>
              <li>
                <button type="button" className="p-link" onClick={logout}>
                  <i className="pi pi-power-off"></i>
                  <span>Logout</span>
                </button>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AppTopbar;
